<template>
  <section class="bg-white d-flex justify-content-start align-items-center flex-column py-5 container-page">
    <router-link to="/" class="pb-5">
      <b-img-lazy
        :src="require(`@/assets/images/logo.png`)"
        width="300"
      />
    </router-link>

    <form-sell
      class="shadow form-sell pb-4"
    />
  </section>
</template>

<script>
import Form from '@/components/FormSellMyVehicle'
export default {
  components: {
    'form-sell': Form
  }
}
</script>

<style lang="scss" scoped>
  .form-sell {
    width: 400px;
    @media screen and (max-width: 400px) {
      width: 100%;
    }
  }

  .container-page {
    display: flex;
    width: 85vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 7.5vw;
    z-index: 999;
    box-shadow: 0px 0px 121px 200px rgba(255,255,255,.99);
    background: url('../assets/icons/iso/vender-carro.svg');
    background-size: 40%;
    background-position: left bottom;
    background-repeat: no-repeat;
    overflow-y: auto;
  }
</style>
